// extracted by mini-css-extract-plugin
export default {"container":"h1MRZdeK"};